/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import { InboundTaskItemStatusEnum } from 'commons/enums';
import {
  IInboundInvoice,
  IInboundInvoiceWaitingApprovalListItem,
  IInboundItemIdentifier,
  IInboundTaskItem,
  InboundInvoiceState,
} from 'commons/types';
import { ReducerKeys } from 'redux-stores/enums/reducerKey.enum';

const initialState: InboundInvoiceState = {
  inboundInvoice: null,
  waitingApprovalInvoiceList: [],
};

const inboundInvoiceSlice = createSlice({
  name: ReducerKeys.InboundInvoice,
  initialState,
  reducers: {
    setInboundInvoice(
      state: InboundInvoiceState,
      action: { type: string; payload: IInboundInvoice | null },
    ) {
      state.inboundInvoice = action.payload;
    },
    setWaitingApprovalInvoiceList(
      state: InboundInvoiceState,
      action: {
        type: string;
        payload: IInboundInvoiceWaitingApprovalListItem[];
      },
    ) {
      state.waitingApprovalInvoiceList = action.payload;
    },
    updateInboundInvoiceItem(
      state: InboundInvoiceState,
      action: { type: string; payload: IInboundTaskItem },
    ) {
      if (state.inboundInvoice && state.inboundInvoice.items) {
        const updatedItems = state.inboundInvoice.items.map((item) =>
          item.sku_code === action.payload.sku_code &&
          item.foc === action.payload.foc
            ? action.payload
            : item,
        );

        state.inboundInvoice = { ...state.inboundInvoice, items: updatedItems };
      }
    },
    bulkUpdateInboundInvoiceItemStatus(
      state: InboundInvoiceState,
      action: {
        type: string;
        payload: {
          items: IInboundItemIdentifier[];
          approved: boolean;
        };
      },
    ) {
      const { payload } = action;
      if (state.inboundInvoice && state.inboundInvoice.items) {
        const newItemList = state.inboundInvoice.items.map((item) => {
          if (
            payload.items.some(
              (payloadItem) =>
                item.sku_code === payloadItem.sku_code &&
                item.foc === payloadItem.foc,
            )
          )
            return {
              ...item,
              status: payload.approved
                ? InboundTaskItemStatusEnum.APPROVED
                : InboundTaskItemStatusEnum.REJECTED,
            };

          return item;
        });
        state.inboundInvoice = { ...state.inboundInvoice, items: newItemList };
      }
    },
  },
});

export const {
  setInboundInvoice,
  updateInboundInvoiceItem,
  bulkUpdateInboundInvoiceItemStatus,
  setWaitingApprovalInvoiceList,
} = inboundInvoiceSlice.actions;

export default inboundInvoiceSlice.reducer;
